module.exports = __webpack_public_path__ + "static/top-25-2020-1fdcf8344188c969fcfe337421ea9205.png";